import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { ItemDto } from "src/dtos/item/itemDto";

import { DropDownForm } from "src/components/common/form/DropdownForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { useKSK2080_R01Store } from "./Store_KSK2080_R01";
import { ImageForm } from "src/components/common/form/ImageForm";
import { defaultKSK2080_R01Dto, KSK2080_R01Dto } from "./Dto_KSK2080_R01";
import { searchCustomer } from "src/apis/customerApi";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import useUiuxStore from "src/store/useUiuxStore";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { CodeForm } from "src/components/common/form/CodeForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";
import { getEmployeeList } from "src/apis/employeeApi";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import DateRangePickerForm from "src/components/common/form/date/DateRangePickerForm";
import { DateRange } from "react-day-picker";
import { CheckboxButtonForm } from "src/components/common/form/checkbox/CheckboxButtonForm";
import { TextareaForm } from "src/components/common/form/input/TextareaForm";
import { inputFormHeightOption } from "src/components/common/common";

interface Props {
 		 data?: ItemDto;
}

export const Info_KSK2080_R01 = ({ data }: Props) => {

	const { setCodeSearchModalProps } = useUiuxStore();
	const { selectedKSK2080_R01, editKSK2080_R01, setEditKSK2080_R01 } = useKSK2080_R01Store();

	const [writerDtVisible, setWriterDtVisible] = useState(false);
	const [writerDtPickerPos, setWriterDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPos, setPickerPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput'; // 게시자 포커스 ID 추가

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'empNo',
			category: '사원번호',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo : 'writerEmpNo',
				empNm : 'writerEmpNm',
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			}
		}
	];
	
	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editKSK2080_R01,
		setEditData: setEditKSK2080_R01,
		defaultData: defaultKSK2080_R01Dto,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS1020_R01'
	});

	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;
		if (!editKSK2080_R01) return;

		setEditKSK2080_R01({ ...editKSK2080_R01, [name]: value });
	};

	const infoInputStyle = {
		wrapperStyle: "w-[100px] min-w-[100px] mr-[10px] mb-[5px]",
		titleStyle: "w-[150px] min-w-[150px] text-left",
		inputStyle: "w-[100px] min-w-[100px] text-right"
	}

	const itemImagewrapperOption = {
		wrapperStyle: "w-[250px] h-[250px]",
	}
	
	const handleDateChange = useCallback((field: keyof KSK2080_R01Dto, value: any) => {
	
		setEditKSK2080_R01({
			...defaultKSK2080_R01Dto,
			...editKSK2080_R01,
			[field]: value ? toLocalDateTime(value) : toLocalDateTime(new Date()),
		});
	}, [editKSK2080_R01]);

	const handleDateRangeChange = useCallback((value: DateRange) => {
		setEditKSK2080_R01({
			...defaultKSK2080_R01Dto,
			...editKSK2080_R01,
			noticeDateRange: value,
			noticeFromDt: value.from ? formatDate(value.from) : formatDate(new Date()),
			noticeEndDt: value.to ? formatDate(value.to) : formatDate(new Date()),
		});
	}, [editKSK2080_R01]);

	return (
		<div className="w-full h-full flex flex-col border border-gray-300 px-[6px] py-[6px] overflow-x-auto">
			<div className="w-full flex items-center">
				<InputForm title="No"			value={editKSK2080_R01?.noticeNo || ''}			editable={false} 					name="noticeNo"				onChange={handleChange} />
				<SingleDateForm
					title="게시일"
					value={editKSK2080_R01?.writerDt ? new Date(editKSK2080_R01.writerDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('writerDt', value)}
					editable={false}
					visible={writerDtVisible}				setVisible={setWriterDtVisible}
					onChange={handleChange}
					pickerPos={writerDtPickerPos}						setPickerPos={setWriterDtPickerPos}
				/>
			</div>
			<InputForm title="제목" value={editKSK2080_R01?.noticeTitle || ""} editable={false} wrapperOption={{
				wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[5px]",
				titleStyle: "w-[150px] min-w-[150px] text-left",
				inputStyle: "w-[410px] min-w-[410px]"
			}} name="noticeTitle" onChange={handleChange} />
			
			<CodeForm
				label="게시자"
				value={editKSK2080_R01?.writerEmpNo || ""}
				custNmValue={editKSK2080_R01?.writerEmpNm || ""}
				editable={false}
				codeInputless={true}
				handleFoucsId={empInfoHandleFoucsId}
				name="writerEmpNo"
				handleChange={handleChange}
				onDoubleClick={() =>{}}
				onKeyDown={() => { }}
			/>
			<DateRangePickerForm
				label="게시 기간"
				visible={pickerVisible}							setVisible={setPickerVisible}
				editable={false}
				dateRange={editKSK2080_R01?.noticeDateRange ?? { from: new Date(), to: new Date() }}
				setDateRange={handleDateRangeChange as (dateRange: DateRange | undefined) => void}
				pickerPosition={pickerPos}
				setPickerPosition={setPickerPos}
			/>
			<TextareaForm
				title="본문"
				value={editKSK2080_R01?.noticeComment || ""}
				name="noticeComment"
				editable={false}
				titleless={true}
				wrapperOption={{
					wrapperStyle: "w-full min-w-full pr-[10px] mb-[5px] h-full",
					titleStyle: "w-[150px] min-w-[150px] text-left",
					inputStyle: "w-full min-w-full h-full" + inputFormHeightOption
				}}
				onChange={(e) => { setEditKSK2080_R01({
					...defaultKSK2080_R01Dto,
					...editKSK2080_R01,
					noticeComment: e.target.value }) 
				}}
			/>
		</div>
	)
}
